// src/lib/seo.ts
//
// Helper pour générer les meta tags OG/Twitter de chaque page.
// Utilise la route /og.png pour les images dynamiques.

import { SITE_URL } from './constants/links';
import { socialMediaHandles } from './constants/seo';

export const SITE_NAME = 'Juslin Komenan';
export const prerender = false;

// ── Types ──
interface BaseMeta {
	title: string;
	description: string;
	url?: string;
}

interface ArticleMeta extends BaseMeta {
	type: 'article';
	category?: string;
	date?: string;
}

interface PageMeta extends BaseMeta {
	type: 'home' | 'project' | 'service' | 'contact';
}

export type SeoMeta = ArticleMeta | PageMeta;

// ── Génère l'URL de l'image OG ──
export function buildOgImageUrl(meta: SeoMeta): string {
	const params = new URLSearchParams({
		title: meta.title,
		excerpt: meta.description,
		type: meta.type
	});

	if (meta.type === 'article') {
		if (meta.category) params.set('category', meta.category);
		if (meta.date) params.set('date', meta.date);
	}

	return `${SITE_URL}/og.png?${params.toString()}`;
}

/**
 * Génère tous les meta tags sous forme d'objet
 * À passer dans <svelte:head> ou dans le load() de chaque page
 * @param meta
 * @returns
 */
export function buildSeoMeta(meta: SeoMeta): Record<string, string> {
	const ogImage = buildOgImageUrl(meta);
	const pageUrl = meta.url ?? SITE_URL;
	const title =
		meta.type === 'home' ? `${meta.title} — ${SITE_NAME}` : `${meta.title} · ${SITE_URL}`;

	return {
		title, // <title> + og:title + twitter:title
		description: meta.description, // meta description + og:description + twitter:description
		url: pageUrl, // canonical + og:url
		image: ogImage, // og:image + twitter:image
		imageAlt: meta.title, // og:image:alt
		type: meta.type === 'article' ? 'article' : 'website', // og:type
		twitterCreator: socialMediaHandles.x // 🔧 ton handle X
	};
}
